import { useNavigate } from 'react-router-dom';
import RetailerLayout from './RetailerLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function SettingsPageShell({ user, onLogout, title, subtitle, children, actions }) {
  const navigate = useNavigate();
  return (
    <RetailerLayout user={user} onLogout={onLogout}>
      <div className="space-y-6 max-w-4xl mx-auto pb-12">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/retailer/settings')}
          data-testid="settings-back-button"
          className="text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Settings
        </Button>
        <div className="bg-gradient-to-r from-slate-900 to-indigo-900 rounded-2xl p-8 text-white shadow-xl">
          <div className="flex items-start justify-between flex-wrap gap-3">
            <div>
              <h1 className="text-3xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>{title}</h1>
              {subtitle && <p className="text-indigo-100 mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex gap-2">{actions}</div>}
          </div>
        </div>
        {children}
      </div>
    </RetailerLayout>
  );
}
